export enum StrengthPenalty {
  Unknown,
  NoLowerLetters,
  NoUpperLetters,
  NoNumbers,
  NoSymbols,
  TooShort,
}
